import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=17bd8c5b"
import script from "./Favorites.vue?vue&type=script&lang=ts"
export * from "./Favorites.vue?vue&type=script&lang=ts"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=17bd8c5b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports